<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!--title -->
        <div class="grid-title no-border borderTop">
          <h4 style="padding-left: 6px"> {{ i18nValues["userEdition"] }} </h4>
        </div>        
  
        <!-- body -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0" :model="user" ref="formUser" :rules="rules">
            <div class="gridTemplate">
  
                <!-- UserId -->    
                <el-form-item :label="i18nValues['user']" prop="userId"> 
                  <el-input v-model="userToSave.userId" maxlength="100"></el-input>
                </el-form-item>   

                <!-- Name -->    
                <el-form-item :label="i18nValues['name']" prop="name"> 
                  <el-input v-model="userToSave.name" maxlength="100"></el-input>
                </el-form-item>      

                 <!-- Password -->  
                <el-form-item :label="i18nValues['password']" prop="password"> 
                  <el-input v-model="userToSave.password" type="password" ></el-input>
                </el-form-item>   

                 <!-- Profile Components -->  
                 <el-form-item :label="i18nValues['profiles']" prop="profileComponents"> 
                  <el-select
                    v-model="userToSave.profileComponents"
                    :placeholder="i18nValues['profileComponents']"
                  >
                    <el-option
                      v-for="item in ProfilesList"
                      :key="item.id"
                      :label="item.identification"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>  

                <!-- FieldSties --> 
                <el-form-item :label="i18nValues['fieldSites']" prop="fieldSites">
                  <el-select 
                    v-model="userToSave.fieldSiteIds" 
                    :placeholder="i18nValues['fieldSites']"
                    multiple
                  >
                    <el-option
                      v-for="item in FieldSitesList"
                      :key="item.id" 
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
  
            </div>          
          </el-form>
  
          <!-- CANCEL/SAVE --> 
          <div class="full-width d-flex justify-content-end mt-2">
            <el-button :loading="loading" size="small" @click="cancel()">
              {{ i18nValues["cancel"] }}
            </el-button>
            <el-button icon="fas fa-check" :loading="loading" size="small" class="btn-primary" @click="save()">
              {{ i18nValues["save"] }}
            </el-button>
          </div>  
  
        </div>      
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  export default {
    name: "UserEdition",  
  
    async created() {
        try {
            await this.retrieveFieldSites();

            this.retrieveProfiles();

            if (this.userId != null) {
                this.retrieveById();
            } 
            // Capture initial query to preserve filters/pagination when returning
            this.returnQuery = { ...this.$route.query };
        } catch (err) {
            console.log("Error al cargar las plantas:", err);//eslint-disable-line
        }
    },
  
    components: {
      
    },
  
    computed: {
      loading: get("customer/loading"),
    },

    watch: {
      i18nValues: {
        handler() {
          this.retrieveProfiles();
        },
        deep: true,
      },
    },
  
    props:["userId"],
  
    data() {
      return {
  
        user: {},
        userToSave: {},
  
        rules:{},

        ProfilesList: [],


        profileComponentsList: [],
        FieldSitesList: [],

        returnQuery: {},

      };
    },
  
    methods: {
      save(){
        this.userToSave.fieldSites = this.userToSave.fieldSiteIds.map(id => {
          const fieldSite = this.FieldSitesList.find(fieldSite => fieldSite.id === id);
          return { id: fieldSite.id, name: fieldSite.name };
        });

        this.$refs["formUser"].validate(valid => {
          if(valid){
            var profile = {};
            profile.id = this.userToSave.profileComponents;
            this.profileComponentsList.push(profile);
            this.userToSave.profiles = this.profileComponentsList;
            // console.log("User:", this.userToSave);//eslint-disable-line
            this.$store.dispatch("user/saveUser", this.userToSave).then((res) =>{            
              if(res.status == "OK"){
                  this.$notify.success({
                      title: this.i18nValues["succes"],
                      message: this.i18nValues["userSaved"],
                      position: "bottom-right",
                  });      
                  this.$router.push({name:"UserAdmin", query: this.returnQuery});    
              } else {
                  this.$notify.error({
                      title: this.i18nValues["error"],
                      message: this.i18nValues["userSaveError"],
                      position: "bottom-right",
                  });
              }           
            });
          }
        });
      },
  
      cancel(){
          this.$router.push({name:"UserAdmin", query: this.returnQuery});
      },
  
      retrieveById() {
        this.$store.dispatch("user/retrieveUserById", { userId: this.userId }).then((res) => {
          this.user = res;

          // for (var i = 0; i < this.user.profiles.length; i++) {
          //   for (var j = 0; j < this.ProfilesList.length; j++) {
          //     if (this.user.profiles[i].id == this.ProfilesList[j].id) {
          //       this.user.profileComponents = this.ProfilesList[j].id;
          //       this.setFieldSiteIds();
          //     }
          //   }
          // }

          this.user.profileComponents = this.user.profiles[0].id;

          this.setFieldSiteIds();
          
          this.userToSave = { ...this.user };
        });
      },


      setFieldSiteIds() {
        if (!this.user.fieldSiteIds || !this.user.fieldSites) {
          this.user.fieldSiteIds = [];
          this.user.fieldSites = [];
        }


        this.FieldSitesList.forEach((field) => {
          field.users.forEach((userToCheck) => {
            if (userToCheck.userId === this.user.userId) {
              let fieldSite = {
                id: field.id,
                name: field.name,
              };
              this.user.fieldSites.push(fieldSite);
            }
          });
        });

        this.user.fieldSiteIds = this.user.fieldSites.map((fieldSite) => fieldSite.id);
      },

      retrieveProfiles(){
         this.$store.dispatch("user/retrieveProfiles").then((res)=>{
            this.ProfilesList = res; 
            this.updateProfilesWithNewI18n();
        });
      },

      updateProfilesWithNewI18n() {
              this.ProfilesList.forEach(profile => {
                  if (profile.identification === 'Limpieza Silo') {
                      profile.identification = this.i18nValues["siloCleaning"];
                  }

                  if (profile.identification === 'Administrador') {
                      profile.identification = this.i18nValues["administrator"];
                  }

                  if (profile.identification === 'Producción Campo') {
                      profile.identification = this.i18nValues["fieldProduction"];
                  }

                  if (profile.identification === 'Producción Total') {
                      profile.identification = this.i18nValues["totalProduction"];
                  }

                  if (profile.identification === 'Producción Planta') {
                      profile.identification = this.i18nValues["plantProduction"];
                  }

                  if (profile.identification === 'Producción IA') {
                      profile.identification = this.i18nValues["aiProduction"];
                  }
              });      
      },

      async retrieveFieldSites() {
          try {
            await this.$store.dispatch("fieldSite/retrieveFieldSites").then((res) => {
              this.FieldSitesList = res;
            });
          } catch (err) {
            console.log("Error:", err);//eslint-disable-line
          }
      },


    },
  
  
  }
  </script>
  
  <style>
  
  </style>